export function defaultAudiobookForm() {
  return {
    title: '',
    category: '',
    author: '',
    type: '',
    year: '',
    publishedDate: '',
    original: '',
    imageurl: '',
    description: '',
    pageCount: '',
    language: 'FR',
    date: new Date().toISOString().substring(0, 10),
    read: 'N',
    rating: '3',
    path: 'G:/audiobooks',
    filename: '',
    tag: '',
    marked: '',
  }
}

export function timeConvert(minutes) {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${hours}h${mins}`
}

export function appendAudiobookFormData(formData, audiobook) {
  Object.entries(audiobook).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value))
    }
  })
}

export function posterSrc(audiobook) {
  if (audiobook?.imageurl) return audiobook.imageurl
  if (audiobook?.image) return `/uploads/${audiobook.image}`
  return ''
}
